//
// Wait for jQuery to be initialized and ready.
// =====================================================================

jQuery(function($) {

	$('#offCanvas').offcanvas({
	    modifiers: 'right, overlay', // default options
	    triggerButton: '#triggerButton' // btn to open offcanvas
	});

	$('#offCanvas2').offcanvas({
	    modifiers: 'top, overlay', // default options
	    triggerButton: '#triggerButton2' // btn to open offcanvas
	});

	var navOffCanvas = $('#offCanvas').data('offcanvas-component');
	var searchOffCanvas = $('#offCanvas2').data('offcanvas-component');

	searchOffCanvas.onOpen = function() {
	    navOffCanvas.close();
	};

	navOffCanvas.onOpen = function() {
	    searchOffCanvas.close();
	};


	$( window ).resize(function() {
	  searchOffCanvas.close();
	  navOffCanvas.close();
	});

});


